import { Context, type Effect, type Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { ObservationInput, ObservationSnapshot, ObservationKind, ObservationCommand } from "./model.ts";
export interface ObservationSettlement { readonly key: string; readonly presented: boolean; readonly success: boolean }
export interface ObservationSession {
  readonly snapshot: Atom.Atom<AsyncResult.AsyncResult<ObservationSnapshot>>;
  readonly read: Effect.Effect<ObservationSnapshot>;
  readonly receive: (input: ObservationInput) => Effect.Effect<void>;
  readonly dispatch: (inputKey: string, command: ObservationCommand) => Effect.Effect<void>;
  readonly settlements: Effect.Effect<{ readonly total: number; readonly recent: readonly ObservationSettlement[] }>;
}
export class ObservationSessions extends Context.Service<ObservationSessions, {
  readonly open: (kind: ObservationKind) => Effect.Effect<ObservationSession, never, Scope.Scope>;
}>()("workerstation/frontend/ObservationSessions") {}
export class ObservationBrowserIo extends Context.Service<ObservationBrowserIo, {
  readonly confirmClear: (kind: ObservationKind) => Effect.Effect<boolean, ResourceFailure>;
  readonly copy: (text: string) => Effect.Effect<void, ResourceFailure>;
  readonly openRecording: (workspaceId: string, sessionId: string) => Effect.Effect<void, ResourceFailure>;
}>()("workerstation/frontend/ObservationBrowserIo") {}
